import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
	selector: 'formly-wrapper-uppercase',
	template: ` <ng-container #fieldComponent></ng-container> `,
})
export class UppercaseWrapperComponent extends FieldWrapper implements OnInit {
	destroyRef = inject(DestroyRef);

	ngOnInit(): void {
		const ctrl = this.field?.formControl;
		if (ctrl) {
			ctrl.valueChanges
				.pipe(takeUntilDestroyed(this.destroyRef))
				.subscribe((val) => {
					const upper = val?.toUpperCase?.();
					if (val !== upper) {
						ctrl.setValue(upper, { emitEvent: false });
					}
				});
		}
	}
}
